// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"0b44e436","377":"fd7aa48b","417":"4d82e43e","467":"89872437","626":"e5e40771","870":"aa07b570"}[chunkId] + ".js";
};